/// <amd-module name="Wit/WorkItemForm/Links/WorkItem/HyperlinkForm" />
import * as React from "react";
import { useState } from "react";
import { FormItem } from "VSSUI/FormItem";
import { TextField } from "VSSUI/TextField";
import { ArtifactsUpdatedCallback } from "Wit/WorkItemLinksRegistration/IRegisteredLinkTypeService";
import { LinkTypeFieldIds, ToolIds } from "Wit/WorkItemLinksRegistration/Constants";
import { getLinkTypeDisplayName } from "Wit/WorkItemLinksRegistration/LinkUtils";
import * as Resources from "Wit/WorkItemForm/Resources";

interface IHyperlinkFormProps {
    linkType: string;
    onArtifactsUpdated: ArtifactsUpdatedCallback;
}

export function HyperlinkForm({ linkType, onArtifactsUpdated }: IHyperlinkFormProps) {
    const [hyperlink, setHyperlink] = useState("");
    return (
        <FormItem label={Resources.HyperlinkAddressLabel}>
            <TextField
                value={hyperlink}
                onChange={(e, val) => {
                    setHyperlink(val);
                    if (isValidHyperlink(val)) {
                        onArtifactsUpdated([
                            {
                                linkIdentifier: {
                                    tool: ToolIds.WorkItemTracking,
                                    FldID: LinkTypeFieldIds.Hyperlink,
                                    FilePath: val
                                },
                                title: val,
                                id: val,
                                uri: val,
                                displayId: val,
                                registeredLinkType: getLinkTypeDisplayName(linkType),
                                tool: ToolIds.WorkItemTracking,
                                linkTypeDisplayName: linkType,
                                icons: [{ iconName: "Link" }]
                            }
                        ]);
                    }
                }}
            />
        </FormItem>
    );
}

function isValidHyperlink(href: string) {
    return true; // TODO:Replat
}
